import { render, staticRenderFns } from "./WebPageRulesSettingDialog.vue?vue&type=template&id=b226e40e&scoped=true"
import script from "./WebPageRulesSettingDialog.vue?vue&type=script&lang=ts"
export * from "./WebPageRulesSettingDialog.vue?vue&type=script&lang=ts"
import style0 from "./WebPageRulesSettingDialog.vue?vue&type=style&index=0&id=b226e40e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b226e40e",
  null
  
)

export default component.exports